export const API_PATH_ApiLanePlanningArchive = '/services/lane-planning/apiLanePlanningArchive';
